var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var createMeetingData = function (meetings, prefix, minBarHeight) {
    var result = {};
    for (var _i = 0, meetings_1 = meetings; _i < meetings_1.length; _i++) {
        var meeting = meetings_1[_i];
        result["".concat(prefix, "_").concat(meeting.id)] = Math.max(meeting.durationSeconds, minBarHeight);
        result["".concat(prefix, "_").concat(meeting.id, "_attendance")] = meeting.attendance;
        result["".concat(prefix, "_").concat(meeting.id, "_title")] = meeting.title;
        result["".concat(prefix, "_").concat(meeting.id, "_original_duration")] =
            meeting.durationSeconds;
    }
    return result;
};
export var collectMeetingAttendanceIds = function (chartSource) {
    var uniqueMeetingIds = [];
    var meetingAttendanceById = new Map();
    var addMeetings = function (meetings) {
        for (var _i = 0, meetings_2 = meetings; _i < meetings_2.length; _i++) {
            var meeting = meetings_2[_i];
            if (!meetingAttendanceById.has(meeting.id)) {
                uniqueMeetingIds.push(meeting.id);
            }
            meetingAttendanceById.set(meeting.id, meeting.attendance);
        }
    };
    for (var _i = 0, _a = chartSource.prevPeriods; _i < _a.length; _i++) {
        var period = _a[_i];
        addMeetings(period.meetings);
    }
    for (var _b = 0, _c = chartSource.periods; _b < _c.length; _b++) {
        var period = _c[_b];
        addMeetings(period.meetings);
    }
    return { uniqueMeetingIds: uniqueMeetingIds, meetingAttendanceById: meetingAttendanceById };
};
export var buildMeetingAttendanceChartData = function (_a) {
    var chartSource = _a.chartSource, getMatchedPrevPeriod = _a.getMatchedPrevPeriod, teamPeriods = _a.teamPeriods, showTeamBars = _a.showTeamBars, minBarHeight = _a.minBarHeight;
    return chartSource.periods.map(function (period, index) {
        var _a;
        var prevPeriod = getMatchedPrevPeriod(index);
        var teamPeriod = teamPeriods === null || teamPeriods === void 0 ? void 0 : teamPeriods[index];
        var teamAttendedDuration = teamPeriod
            ? Math.max(teamPeriod.teamAverageAttended, minBarHeight)
            : 0;
        var teamSkippedDuration = teamPeriod
            ? Math.max(teamPeriod.teamAverageSkipped, minBarHeight)
            : 0;
        return __assign(__assign(__assign({ period: period.period }, createMeetingData(period.meetings, 'meeting', minBarHeight)), createMeetingData((_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.meetings) !== null && _a !== void 0 ? _a : [], 'prev_meeting', minBarHeight)), (showTeamBars
            ? {
                teamAverageAttended: teamAttendedDuration,
                teamAverageSkipped: teamSkippedDuration
            }
            : {}));
    });
};
export var isMeetingAttendanceSeriesVisible = function (meetingAttendanceById, meetingId, isSeriesVisible) {
    var attendance = meetingAttendanceById.get(meetingId);
    if (attendance === undefined) {
        return true;
    }
    return isSeriesVisible(attendance ? 'attended' : 'missed');
};
